import { createSlice } from '@reduxjs/toolkit';

type ModeType = 'flex' | 'scheduled';

type LyftSliceType = {
  mode: ModeType;
};

const initialState: LyftSliceType = {
  mode: 'scheduled',
};

export const lyftSlice = createSlice({
  name: 'lyft',
  initialState,
  reducers: {
    setMode(state, { payload }: { payload: ModeType }) {
      state.mode = payload;
    },
  },
});

export const selectLyftConfiguration = (state: {
  lyftConfigs: LyftSliceType;
}) => state.lyftConfigs;

export const { setMode } = lyftSlice.actions;
export const lyftReducer = lyftSlice.reducer;
